import { render } from "./notice.vue?vue&type=template&id=15349bf8&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=15349bf8&scoped=true&lang=less"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15349bf8"]])

export default __exports__